import type { UIMessageFileMetadata } from '../../../lib/types';

export function isFolderMessageFile(file: UIMessageFileMetadata) {
  return file.kind === 'folder';
}

export function getMessageFileDisplayName(file: UIMessageFileMetadata) {
  return isFolderMessageFile(file) ? (file.folderName ?? file.filename) : file.filename;
}

export function getMessageFileDisplayLabel(file: UIMessageFileMetadata) {
  const displayName = getMessageFileDisplayName(file);

  if (!isFolderMessageFile(file) || typeof file.fileCount !== 'number') {
    return displayName;
  }

  return `${displayName} (${file.fileCount} ${file.fileCount === 1 ? 'file' : 'files'})`;
}

export function getMessageFileDownloadFilename(file: UIMessageFileMetadata) {
  return file.archiveFilename ?? file.filename;
}
